'use client'

import { useAuth, useFSTrackEvent } from '@/dc-shared-web/src'
import Header from '@/app/core/components/Header'
import { useEffect } from 'react'
import { FS } from '@/dc-shared-web/src/lib/trackingConstants'
import { useLDFlags } from '@/app/core/hooks/useLDFlags'

export default function HeaderWithHelpCenter() {
  const { trackEvent: trackFSEvent } = useFSTrackEvent()
  const { user, isAuthenticating } = useAuth()
  const {
    flags: { rr1433PylonIntegration },
  } = useLDFlags()

  useEffect(() => {
    if (rr1433PylonIntegration && !isAuthenticating && window.Pylon) {
      window.pylon = {
        chat_settings: {
          ...window.pylon?.chat_settings, // App ID is already set in WithPylonProvider
          email: user.email,
          name: user.name,
          email_hash: user.pylon_hash,
        },
      }
    }
  }, [rr1433PylonIntegration, isAuthenticating, user])

  const onClickHelpCenter = () => {
    trackFSEvent(FS.BUTTON_CLICKED, {
      name: 'Help Center',
    })
    if (window.Pylon) {
      window.Pylon('show')
    }
  }

  return <Header onClickHelpCenter={onClickHelpCenter} />
}
